export default __webpack_public_path__ + "static/media/blog-post-layout-04-img-01.9e128a31.jpg";